import React from "react";

import type { PatientConsent } from "@/core/types";
import { DashboardCard2 } from "@/ui2/molecules/DashboardCard2";
import { OptOutButton } from "./OptOutButton";
import { SectionDetailList } from "./SectionDetailList";
import { getACPStatus } from "@/lib/helpers/getACPStatus";
import { getLatestACPConsent } from "@/lib/helpers/getLatestACPConsent";
import { isAuthorized } from "@/redux/actions/auth";
import { admin_cse } from "@/config/roles";

type MemberProfileACPSectionProps = {
  consents: PatientConsent[];
  insuranceCarrier: string;
};

export function MemberProfileACPSection({
  consents,
  insuranceCarrier,
}: MemberProfileACPSectionProps) {
  const latestACPConsent = getLatestACPConsent(consents);
  const { consentResponse, entityId, responseGivenByName, sortKey } = latestACPConsent || {};
  const consentStatus = getACPStatus({ consentResponse, insuranceCarrier });
  const isCSE = isAuthorized(admin_cse);

  return (
    <DashboardCard2
      Actions={
        consentStatus === "OPTED_IN" &&
        isCSE && (
          <OptOutButton patientId={entityId} patientName={responseGivenByName} sortKey={sortKey} />
        )
      }
      title="Advanced Care Program Status"
    >
      <SectionDetailList consent={latestACPConsent} consentStatus={consentStatus} />
    </DashboardCard2>
  );
}
